import { LABEL } from '../../veriables';

export default {
  1: {
    countryCode: 1,
    higherUnit: {
      symbol: '$',
      unit: 'dollar',
      type: 'Bill',
      currencyList: [100, 20, 10, 5, 1]
    },
    lowerUnit: {
      symbol: '¢',
      unit: 'cent',
      type: 'Coin',
      currencyList: [100, 50, 25, 10, 5, 1]
    },
    conversionUnit: 100,
    cummulativeUnit: [10000, 2000, 1000, 500, 100, 25, 10, 5, 1]
  },
  44: {
    countryCode: 44,
    higherUnit: {
      symbol: LABEL().CURRENCY_SYMBOL,
      unit: 'euro',
      type: 'Bill',
      currencyList: [100, 50, 20, 10, 5, 2, 1]
    },
    lowerUnit: {
      symbol: 'p',
      unit: 'pen',
      type: 'Coin',
      currencyList: [50, 20, 10, 5, 2, 1]
    },
    conversionUnit: 100,
    cummulativeUnit: [10000, 5000, 2000, 1000, 500, 200, 100, 50, 10, 5, 1]
  },
  91: {
    countryCode: 91,
    higherUnit: {
      symbol: '₹',
      unit: 'rupee',
      type: 'Bill',
      currencyList: [2000, 500, 100, 50, 20, 10, 5, 2, 1]
    },
    lowerUnit: {
      symbol: 'p',
      unit: 'paisa',
      type: 'Coin',
      currencyList: [50, 25]
    },
    conversionUnit: 100,
    cummulativeUnit: [200000, 50000, 10000, 5000, 2000, 1000, 500, 200, 100, 50, 25, 10]
  }
};
